import React from 'react';
import YouTube from 'react-youtube';

import useModal from '../../../../../hooks/useModal';
import { useMission1 } from './useMission1';

import Checkbox from './checkbox';
import Mission1Quiz from './mission1Quiz/';
import MissionResultToast from '../missionResultToast';

import IntroBackground from '../asset/1-intro-background.png';
import IntroDescription from '../asset/2-intro-description.png'
import Mission1Text from '../asset/3-mission1-Text.png';
import Mission1Img from '../asset/4-mission1-Img.png';
import Mission1BtnSubmit from '../asset/5-mission1-btn-submit.png';
import Mission1BtnShare from '../asset/6-mission1-btn-share.png';
import Mission1BtnTomorrow from '../asset/7-mission1-btn-tomorrow.png';
import Mission1Tip from '../asset/8-mission1-tip.png';
import Mission1Success from '../asset/9-mission1-success.png';
import Mission1Fail from '../asset/10-mission1-fail.png';

import { BGWrap } from '../styled';

import { 
  YoutubeWrap, 
  SubmitWrap,
  SubmitImg,
  TipWrap,
  TipImg,
} from './styled';

const Misson1Component = ({
  ableMission1,
  updateAbleMisssionState,
  isValidAuth,
}) => {

  const { openModal, ModalPortal, closeModal } = useModal();

  const { 
    checkMission1Condition, 
    watchedYoutube,
    clickUserAgreement,
    onClickItem, 
    submitMission1, 
  } = useMission1(updateAbleMisssionState, isValidAuth, openModal);
  
  const getSubmitBtnType = key => {
    switch (key) {
      case true:
        return Mission1BtnShare
      
      case false:
        return Mission1BtnTomorrow

      case null:
        return Mission1BtnSubmit
      default:
        return ''
    }
  }

  const getMissionResultType = key => {
    if (key === 'success') {
      return Mission1Success
    }

    if (key === 'fail') {
      return Mission1Fail
    }
  }

  return (
    <>
      <BGWrap width={710} height={1134} imgUrl={IntroBackground}>
        <YoutubeWrap>
          <YouTube videoId="wqUtWSGc-64" onPlay={watchedYoutube} />
        </YoutubeWrap>
      </BGWrap>

      <BGWrap width={710} height={276} imgUrl={IntroDescription} />
  
      <Checkbox 
        name='checkPersonalInfoType1'
        label='(필수) 개인정보 수집/이용 에 대한 동의'
        isChecked={checkMission1Condition.checkPersonalInfoType1} 
        checkHander={clickUserAgreement}
      />     

      <BGWrap width={710} height={396} imgUrl={Mission1Text} />  

      <BGWrap width={710} height={580} imgUrl={Mission1Img} />  
      
      <Mission1Quiz 
        selectedResult={checkMission1Condition.selectedResult} 
        onClickItem={onClickItem}
      />

      <SubmitWrap>
        <SubmitImg 
          imgUrl={getSubmitBtnType(ableMission1)} 
          onClick={submitMission1.bind(null, ableMission1)} 
        />
      </SubmitWrap>

      <TipWrap>
        <TipImg imgUrl={Mission1Tip} />
      </TipWrap>

      <ModalPortal>
        <MissionResultToast 
          closeModal={closeModal} 
          missionResultImg={getMissionResultType(checkMission1Condition.submitResult)}
        />
      </ModalPortal>
    </>
  )
}

export default Misson1Component;
